import axios from 'axios';
import api from './api';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// ============================================================
// PUBLIC REVIEW ENDPOINTS
// ============================================================

// Get reviews for a product
export const getProductReviews = async (productId, options = {}) => {
  const { limit = 10, skip = 0, sortBy = 'recent', skinType, ageRange } = options;
  const params = { limit, skip, sortBy };
  
  // Add optional filter params
  if (skinType) params.skinType = skinType;
  if (ageRange) params.ageRange = ageRange;
  
  const response = await axios.get(
    `${API_URL}/products/${productId}/reviews`,
    { params }
  );
  return response.data;
};

// Get review statistics for a product
export const getProductReviewStats = async (productId) => {
  const response = await axios.get(
    `${API_URL}/products/${productId}/reviews/stats`
  );
  return response.data;
};

// Submit a new review
export const submitReview = async (productId, reviewData) => {
  const response = await axios.post(
    `${API_URL}/products/${productId}/reviews`,
    reviewData
  );
  return response.data;
};

// Mark review as helpful
export const markReviewHelpful = async (reviewId, helpful) => {
  const response = await axios.put(
    `${API_URL}/reviews/${reviewId}/helpful`,
    { helpful }
  );
  return response.data;
};

// Flag/report review (with reason)
export const flagReview = async (reviewId, reason = 'other') => {
  const response = await axios.put(
    `${API_URL}/reviews/${reviewId}/flag`,
    { reason }
  );
  return response.data;
};

// ============================================================
// ADMIN REVIEW ENDPOINTS (Protected)
// ============================================================

// Get all reviews with filters (admin dashboard)
export const getAdminReviews = async (filters = {}) => {
  const {
    status,
    limit = 50,
    skip = 0,
    sortBy = 'recent',
    flagged,
    autoFlagged,
    featured,
    search
  } = filters;

  const params = { limit, skip, sortBy };
  
  if (status) params.status = status;
  if (flagged) params.flagged = flagged;
  if (autoFlagged) params.autoFlagged = autoFlagged;
  if (featured) params.featured = featured;
  if (search) params.search = search;

  const response = await api.get('/admin/reviews', { params });
  return response.data;
};

// Get single review details (admin)
export const getReviewDetails = async (reviewId) => {
  const response = await api.get(`/admin/reviews/${reviewId}`);
  return response.data;
};

// Moderate review (hide, restore, delete)
export const moderateReview = async (reviewId, action, notes = '') => {
  const response = await api.put(`/admin/reviews/${reviewId}/moderate`, {
    action,
    notes
  });
  return response.data;
};

// Toggle featured status
export const toggleFeatured = async (reviewId, featured) => {
  const response = await api.put(`/admin/reviews/${reviewId}/feature`, {
    featured
  });
  return response.data;
};

// Bulk moderate reviews
export const bulkModerateReviews = async (reviewIds, action) => {
  const response = await api.put('/admin/reviews/bulk-moderate', {
    reviewIds,
    action
  });
  return response.data;
};



